// Mock data for Lavage de Vitre Bois-Franc website

export const companyInfo = {
  name: "Lavage de Vitre Bois-Franc",
  slogan: "« Votre satisfaction, c'est notre réputation »",
  mission: "Nous sommes une entreprise familiale qui offrons nos services depuis le début du quartier Bois-Franc. Notre mission : vous donner le service courtois et de qualité que votre famille mérite. Lorsque nous quittons votre demeure, la seule différence : des fenêtres propres. Pas de gâchis, pas de souci.",
  
  contact: {
    owner: "Louis-Philippe Fournier",
    phone: "514-570-9802",
    email: "Lavagedevitreboisfranc@live.com"
  },
  
  logo: "https://customer-assets.emergentagent.com/job_simple-web-pro/artifacts/fq5y6lur_IMG_3929.jpeg",
  heroImage: "https://customer-assets.emergentagent.com/job_simple-web-pro/artifacts/jaajc97z_IMG_3801.JPG"
};

export const services = {
  description: "Nous offrons un service complet de lavage de vitres résidentielles incluant :",
  list: [
    "Lavage de vitres extérieures",
    "Lavage de vitres intérieures",
    "Nettoyage de moustiquaires",
    "Nettoyage de cadres de fenêtres",
    "Inspection du mécanisme et calfeutrage"
  ]
};

export const whyChooseUs = [
  {
    id: 1,
    title: "Entreprise Familiale",
    description: "Une approche personnelle et des valeurs familiales dans chaque service."
  },
  {
    id: 2,
    title: "Expertise Locale",
    description: "Nous servons le quartier Bois-Franc depuis ses débuts."
  },
  {
    id: 3,
    title: "Aucun Gâchis",
    description: "Travail propre et soigné, nous ne laissons aucune trace."
  },
  {
    id: 4,
    title: "Service Courtois",
    description: "Un service professionnel avec le sourire, à chaque fois."
  }
];

export const testimonials = [
  {
    id: 1,
    rating: 5,
    text: "Service impeccable avec Louis-Philippe! Mes fenêtres n'ont jamais été aussi propres. Très professionnel et respectueux. Je recommande à 100%!"
  },
  {
    id: 2,
    rating: 5,
    text: "Excellente expérience avec Louis-Philippe et Flor. Ponctuels, efficaces et le résultat est exceptionnel. Mes fenêtres brillent comme jamais! Merci!"
  },
  {
    id: 3,
    rating: 5,
    text: "Je fais appel à Louis-Philippe depuis 20 ans. Toujours satisfaite! Un travail minutieux et aucun dégât. Une entreprise de confiance."
  },
  {
    id: 4,
    rating: 5,
    text: "Très professionnels! Louis-Philippe et Flor ont nettoyé toutes mes fenêtres intérieures et extérieures, même les plus hautes. Résultat impeccable. Je les rappellerai!"
  }
];
